import {
  faBook,
  faPortrait,
  faToolbox,
} from '@fortawesome/pro-solid-svg-icons';
import { TranslateFunction } from 'react-localize-redux';
import { TranslateType } from 'typings';

export type NavParents =
  | 'werkplaats'
  | 'bibliotheek'
  | 'show'
  | 'scanner'
  | 'groei';

export const navItems: (
  translate: TranslateFunction,
  isTeacher: boolean,
  isExtern: boolean
) => {
  name: TranslateType;
  icon: any;
  id: NavParents;
  children: {
    to: string;
    name: TranslateType;
    id: string;
  }[];
}[] = (translate: TranslateFunction, isTeacher: boolean, isExtern: boolean) =>
  isExtern
    ? [
        {
          name: translate('general.terms.projects'),
          icon: faToolbox,
          id: 'werkplaats',
          children: [
            {
              to: '/werkplaats/mijn-projecten',
              name: 'Volgen', // @ToDo: translate
              id: 'mijn-projecten',
            },
            {
              to: '/groei/feedback-geven',
              name: translate('general.terms.feedback'),
              id: 'feedback-geven',
            },
            {
              to: '/groei/beoordelen',
              name: translate('general.terms.judge'),
              id: 'beoordelen',
            },
            // {
            //   to: '/werkplaats/mijn-trainingen',
            //   name: translate('general.terms.my-courses'),
            //   id: 'mijn-trainingen',
            // },
            // {
            //   to: '/werkplaats/mijn-berichten',
            //   name: translate('general.terms.my-messages'),
            //   id: 'mijn-berichten',
            // },
          ],
        },
      ]
    : [
        {
          name: translate('general.terms.library'),
          icon: faBook,
          id: 'bibliotheek',
          children: [
            {
              to: '/bibliotheek/groowtorials',
              name: translate('general.terms.groowtorials'),
              id: 'groowtorials',
            },
            {
              to: '/bibliotheek/bouwstenen',
              name: translate('general.terms.building-blocks'),
              id: 'bouwstenen',
            },
            {
              to: '/bibliotheek/projecten',
              name: translate('general.terms.projects'),
              id: 'projecten',
            },
            {
              to: '/bibliotheek/trainingen',
              name: translate('general.terms.courses'),
              id: 'trainingen',
            },
          ],
        },
        {
          name: translate('general.terms.workspace'),
          icon: faToolbox,
          id: 'werkplaats',
          children: [
            {
              to: '/werkplaats/mijn-projecten',
              name: translate('general.terms.my-projects'),
              id: 'mijn-projecten',
            },
            {
              to: '/werkplaats/mijn-trainingen',
              name: translate('general.terms.my-courses'),
              id: 'mijn-trainingen',
            },
            // {
            //   to: '/werkplaats/mijn-berichten',
            //   name: translate('general.terms.my-messages'),
            //   id: 'mijn-berichten',
            // },
          ],
        },
        {
          name: translate('general.terms.growth'),
          icon: `/images/leaf.svg`,
          id: 'groei',
          children: isTeacher
            ? [
                {
                  to: '/groei/feedback-geven',
                  name: translate('general.terms.feedback'),
                  id: 'feedback-geven',
                },
                {
                  to: '/groei/beoordelen',
                  name: translate('general.terms.judge'),
                  id: 'beoordelen',
                },
                {
                  to: '/groei/studenten-overzicht',
                  name: translate('general.terms.student-overview'),
                  id: 'studenten-overzicht',
                },
              ]
            : [
                {
                  to: '/groei/mijn-reflecties',
                  name: translate('reflection.terms.my-reflections'),
                  id: 'mijn-reflecties',
                },
                {
                  to: '/groei/mijn-beoordelingen',
                  name: translate('general.terms.my-reviews'),
                  id: 'miijn-beoordelignen',
                },
                {
                  to: '/groei/groeiportfolio',
                  name: translate('general.terms.growth-portfolio'),
                  id: 'groeiportfolio',
                },
              ],
        },
        {
          name: 'Show',
          icon: faPortrait,
          id: 'show',
          children: [
            {
              to: '/show/mijn-werk',
              name: translate('general.terms.my-work'),
              id: 'mijn-werk',
            },
            {
              to: '/show/show-portfolios',
              name: translate('general.terms.show-portfolios'),
              id: 'show-portfolios',
            },
          ],
        },
      ];
